__turbopack_context__.v({
  "dot": "BuyersDeal-module-scss-module__Ma0rrG__dot",
  "titleWrapper": "BuyersDeal-module-scss-module__Ma0rrG__titleWrapper",
  "wrapper": "BuyersDeal-module-scss-module__Ma0rrG__wrapper",
});
